<template>
  <v-card color="orders-list" elevation="0" class="px-4">
    <v-divider></v-divider>
    <div class="d-flex align-baseline pt-3 pb-0 mt-2 mb-3">
      <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
        :label="snapSearch ? '' : $t('sales.ordersList.search')" single-line dense hide-details>
        <template v-slot:prepend-inner v-if="snapSearch">
          <v-chip small color="primary"><strong>{{ snapSearch }}</strong> <v-btn icon @click="snapSearch = ''" x-small
              color="error" class="ml-2 mr-n2"><v-icon>mdi-close</v-icon></v-btn></v-chip>
        </template>
      </v-text-field>
      <v-spacer></v-spacer>
      <v-btn-toggle class="mx-2" color="primary" dense v-model="statusGroup">
        <v-btn height="40">{{ $t("sales.ordersList.intention") }}</v-btn>
        <v-btn height="40">{{
          $t("sales.ordersList.planning")
          }}</v-btn>
        <v-btn height="40">{{
          $t("sales.ordersList.checkout") }}</v-btn>
        <v-btn height="40">{{
          $t("sales.ordersList.payment") }}</v-btn>
        <v-btn height="40">{{
          $t("sales.ordersList.placement")
          }}</v-btn>
        <v-btn height="40">{{
          $t("sales.ordersList.finish")
          }}</v-btn>
      </v-btn-toggle>

      <fieldset class="filter-fieldset">
        <div class="d-flex align-top justify-end" style="align-items: stretch">

          <v-btn @click="applyDate(1)" class="mr-1 px-2 py-4" style="height: 40px"
            :color="setCalendar == 1 ? 'primary' : 'gray'" :outlined="setCalendar == 1" :text="setCalendar != 1">
            {{ $t("common.dates.today") }}
          </v-btn>
          <v-btn @click="applyDate(7)" class="mr-1 px-2 py-4" style="height: 40px"
            :color="setCalendar == 7 ? 'primary' : 'gray'" :outlined="setCalendar == 7" :text="setCalendar != 7">
            {{ $t("common.dates.days", { count: 7 }) }}
          </v-btn>
          <v-btn @click="applyDate(15)" class="mr-1 px-2 py-4" style="height: 40px"
            :color="setCalendar == 15 ? 'primary' : 'gray'" :outlined="setCalendar == 15" :text="setCalendar != 15">
            {{ $t("common.dates.days", { count: 15 }) }}
          </v-btn>
          <v-btn @click="applyDate(30)" class="mr-1 px-2 py-4" style="height: 40px"
            :color="setCalendar == 30 ? 'primary' : 'gray'" :outlined="setCalendar == 30" :text="setCalendar != 30">
            {{ $t("common.dates.days", { count: 30 }) }}
          </v-btn>
          <v-btn @click="applyDate(-1)" class="mr-1 px-2 py-4" style="height:40px"
            :color="setCalendar == -1 ? 'primary' : 'gray'" dense :outlined="setCalendar == -1"
            :text="setCalendar != -1">
            {{ $t('common.all') }}
          </v-btn>
          <v-menu offset-y left :close-on-content-click="false" min-width="auto" ref="menu" v-model="filter.date.menu">
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-text-field class="mr-1 no-shadow" :color="setCalendar == 0 ? 'primary' : 'gray'" :outlined="setCalendar == 0" solo elevation="0" label="Data do pedido" dense v-model="dateRangeText" -->
              <v-text-field :color="setCalendar == 0 ? 'primary' : 'gray'" elevation="0" outlined dense
                v-model="dateRangeText" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details
                style="flex: 0 0 190px"></v-text-field>
            </template>
            <v-date-picker no-title v-model="newDates" range>
              <v-spacer></v-spacer>

              <v-btn color="primary" elevation="0" @click="applyDate()">
                {{ $t("common.ok") }}
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
      </fieldset>
      <v-select style="max-width: 70px" hide-details class="ml-1" outlined dense v-model="activeColumns" multiple
        :items="allColumns" item-text="text" item-value="index">
        <template v-slot:selection="{ item, index }">
          <v-icon small v-if="index === 0" :alt="item">
            mdi-filter
          </v-icon>

        </template>

      </v-select>
      <vue-json-to-csv :json-data="toExport" :csv-title="`Pedidos (${computedDateFormatted})`" :separator="';'"
        :labels="csvLabels">
        <v-btn outlined color="primary" class="ml-1 mt-n2" height="34px">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </vue-json-to-csv>


    </div>
    <v-card outlined>

      <v-data-table v-if="status.length && status[0] != 'intention'" :sort-by="['updatedOnX']" :sort-desc="[true]"
        :headers="headers" :items="documents" :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 25, 50],
        }" :items-per-page="25" :search="search" :loading="loading">
        <template v-slot:[`item.client`]="{ item }">
          <v-btn style="padding-left: 0px" text color="primary"
            v-if="item.user && item.user.uid && item.computed.userId"
            :to="`/sales/customers?q=${getClientName(item.user.uid)}`">{{ getClientName(item.user.uid)
            }}<v-icon small class="">mdi-arrow-top-right</v-icon></v-btn>
        </template>
        <template v-slot:[`item.createdOnX`]="{ item }"><span style="display: none">{{ item.computed.createdOn |
            dateTimeX }}</span>
          {{ item.computed.createdOn | dateTimeS }}
        </template>
        <template v-slot:[`item.updatedOnX`]="{ item }"><span style="display: none">{{ item.updatedOn | dateTimeX
            }}</span>
          {{ item.updatedOn | dateTimeS }}
        </template>
          <template v-slot:[`item.range`]="{ item }">
          <div v-if="item && item.range">{{ item.range.start | date }} à {{item.range.end | date}}</div>
          <div v-else>N/C</div>
        </template>

        <template v-slot:[`item.packages`]="{ item }">
          <v-menu offset-y left open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon outlined color="primary" small class="ml-2" v-bind="attrs" v-on="on">
                {{ item.packages.length }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(pack, index) in item.packages" :key="index">
                <v-list-item-avatar>
                  <img v-if="pack.image" :src="pack.image" :alt="pack.name">
                  <img v-if="pack.files" :src="pack.files[0]" alt="">
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-if="pack.name">{{ pack.name }}</v-list-item-title>
                  <v-list-item-title v-else>{{ pack._format }} ({{ pack._coverage }})</v-list-item-title>
                  <v-list-item-subtitle class="d-flex">
                    <div class="pr-2">{{ $tc('common.insertionsCount', item.simulation[index].total.totalSum, {
                      count:
                        item.simulation[index].total.totalSum }) }}
                    </div>

                    <span class="px-1">X</span> <span>{{ $n(pack.rules.pricing.unityPrice, 'currency') }}</span> = <div
                      class="pl-2 font-weight-bold green--text" v-if="pack.rules.pricing.unityPrice">{{
                        $n(pack.rules.pricing.unityPrice * item.simulation[index].total.totalSum, 'currency') }}</div>
                    <v-alert text class="ml-2 pa-2" color="warning" small v-else>Nenhuma data selecionada</v-alert>

                  </v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.total.total`]="{ item }">
          <div v-if="item.total && item.total.total">{{ $n(item.total.total, "currency") }}</div>
        </template>
        <template v-slot:[`item.total.discount`]="{ item }">
          <div v-if="item.total && item.total.discount">{{ $n(item.total.discount, "currency") }}</div>
        </template>
         <template v-slot:[`item.total.couponDiscount`]="{ item }">
          <div v-if="item.total && item.total.couponDiscount">{{ $n(item.total.couponDiscount, "currency") }}
           </div>
        </template>
        <template v-slot:[`item.total.finalWithoutPolicy`]="{ item }">
          <div v-if="item.total && item.total.finalWithoutPolicy">{{ $n(item.total.finalWithoutPolicy, "currency") }}
          </div>
        </template>
        <template v-slot:[`item.total.policyDiscount`]="{ item }">
          <div v-if="item.total && item.total.policyDiscount">{{ $n(item.total.policyDiscount, "currency") }}
            ({{ $n(item.total.policyDiscountPercent) }}%)</div>
        </template>

       

        <template v-slot:[`item.total.final`]="{ item }">
          <div v-if="item.total && item.total.final">{{ $n(item.total.final, "currency") }}</div>
        </template>
        <template v-slot:[`item.computed.userName`]="{ item }">
          {{ item.computed.userName }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip @click="openSkus(item)" :color="$t(`whiteLabelStatus.${item.status}[1]`)" label small>{{
            $t(`whiteLabelStatus.${item.status}[0]`)
            }}</v-chip><v-btn :to="`/sales/opec/?status=pi&q=${item.id}`" v-if="item.status == 'waiting_pi_approval'"
            small color="primary" elevation="0" style="height: 24px " class="ml-1">Avaliar PI <v-icon x-small
              class="ml-2">mdi-open-in-new</v-icon></v-btn>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y left :close-on-content-click="false" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>

            </template>
            <v-list>
              <v-list-item :disabled="statusGroup == 5" @click="cancelOrder(item)">
                <v-list-item-title>{{ $t("order.cancel") }}</v-list-item-title>
              </v-list-item>
              <v-list-item :disabled="statusGroup == 5" @click="editCalendar(item)">
                <v-list-item-title>{{ $t("order.placementEdit") }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openSkus(item)">
                <v-list-item-title>{{ $t("order.update") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template slot="body.prepend">
          <tr>
            <th v-for="h in headers" :key="h.index">
              <template v-if="h.index == 0">
                {{ $t('common.data.totals') }}
              </template>


              <template v-if="h.index == 9">

                {{ $n(totals.total, 'currency') }}
              </template>
              <template v-if="h.index == 10">
                {{ $n(totals.discount, 'currency') }}
              </template>
              <template v-if="h.index == 11">
                {{ $n(totals.couponDiscount, 'currency') }}

              </template>

              <template v-if="h.index == 12">
                {{ $n(totals.policyDiscount, 'currency') }}

              </template>
              <template v-if="h.index == 13">
                {{ $n(totals.final, 'currency') }}

              </template>
            </th>

          </tr>
        </template>

      </v-data-table>

      <v-data-table v-if="status.length && status[0] == 'intention'" :sort-by="['updatedOnX']" :sort-desc="[true]"
        :loading="loadingLog" :headers="headers" :items="filteredLogs" :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 25, 50],
        }" :items-per-page="25">
        <template v-slot:[`item.client`]="{ item }">
          <v-btn style="padding-left: 0px" text color="primary" :to="`/sales/customers?q=${item.user.name}`"
            v-if="item.user && item.user.uid">{{ item.user.company }}<v-icon small
              class="">mdi-arrow-top-right</v-icon></v-btn>
        </template>
        <template v-slot:[`item.user`]="{ item }">
          {{ item.user.name }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.orderName }}
        </template>
        <template v-slot:[`item.createdOnX`]="{ item }">
          <span style="width: 0; position: absolute; opacity: 0; height: 0px">{{ item.createdOnX }}</span>
          {{ item.createdOn | dateTime }}
        </template>
        <template v-slot:[`item.updatedOnX`]="{ item }">
          <template v-if="item.updatedOn">
            <span style="width: 0; position: absolute; opacity: 0; height: 0px">{{ item.updatedOnX }}</span>

            {{ item.updatedOn | dateTime }}</template>
          <template v-else>
            <span style="width: 0; position: absolute; opacity: 0; height: 0px">{{ item.createdOnX }}</span>

            {{ item.createdOn | dateTime }}</template>
        </template>
        <template v-slot:[`item.packages`]="{ item }">
          <v-menu offset-y left open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon outlined color="primary" small class="ml-2" v-bind="attrs" v-on="on">{{ item.type == 'package'
                ?
                1 : 1 }}</v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img :src="item.itemDetails.image" :alt="item.itemDetails.name">
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title>{{ item.itemDetails.name }}</v-list-item-title>
                  <v-list-item-subtitle class="d-flex">
                    <div class="pr-2">1
                    </div> | <div class="pl-2 font-weight-bold green--text">{{ $n(item.itemDetails.price, 'currency') }}
                    </div>
                  </v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.total.total`]="{ item }">
          <div>{{ $n(item.total.total, "currency") }}</div>
        </template>
        <template v-slot:[`item.total.discount`]="{ item }">
          <div v-if="item"></div>
        </template>
        <template v-slot:[`item.total.finalWithoutPolicy`]="{ item }">
          <div v-if="item"></div>
        </template>
        <template v-slot:[`item.range`]="{ item }">
          <div v-if="item && item.range">{{ item }}</div>
          <div v-else></div>
        </template>

        <template v-slot:[`item.total.policyDiscount`]="{ item }">
          <div v-if="item?.total?.policyDiscount">{{ $n(item.total.policyDiscount, "currency") }}</div>
        </template>
        <template v-slot:[`item.total.couponDiscount`]="{ item }">
          <div v-if="item?.total?.couponDiscount">{{ $n(item.total.couponDiscount, "currency") }}</div>
        </template>
        <template v-slot:[`item.total.final`]="{ item }">
          <div>{{ $n(item.total.final, "currency") }}</div>
        </template>
        <template v-slot:[`item.computed.userName`]="{ item }">
          {{ item.computed.userName }}
        </template>
        <template v-slot:[`item.status`]="{ item }">

          <v-chip @click="openSkus(item)" :color="$t(`whiteLabelStatus.viewed[1]`)" label small>{{
            $t(`whiteLabelStatus.viewed[0]`)
            }}</v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="item"></div>
        </template>
      </v-data-table>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="orderModal" width="1280">
        <v-card class="mx-auto pa-3" v-if="orderModal && orderSkus && orderSkus.simulation" width="1280">
          <v-card-title>
            <h4 class="primary--text">
              {{ `Pedido: ${orderSkus.id || $route.params.id}` }}
            </h4>
            <small v-if="orderSkus.gridCode"></small>
          </v-card-title>
          <v-card outlined elevation="0" class="d-flex flex-column my-2 mx-2 pa-2"
            v-for="(sku, skuIndex) in orderSkus.simulation" :key="skuIndex" :class="{
              'disabled-card': sku.asu.status == 'content_reproved',
              'approved-card': sku.asu.status == 'content_approved',
            }">
            <div class="d-flex align-center justify-space-between card-content">
              <v-card-title style="flex: 0 0 50%" class="subtitle-2">
                <div>
                  <div class="d-flex">
                    <div>{{ sku.asu.computed.formatText }}</div>
                    <span class="mx-1" v-for="(bucket, bucketIndex) in sku.asu.buckets" :key="bucketIndex"><strong>{{
                      bucket.title }}:
                      </strong>{{ bucket.name }}</span>
                  </div>
                  <div class="d-flex">
                    <div class="mr-1 text-caption">{{ sku.asu.computed.mediaType.text }}</div>
                    <span class="mx-1 text-caption">- {{ getStoreName(sku.asu.store) }} -</span>
                    <span class="mr-1 text-caption">{{ sku.asu.coverage.join(', ') }}</span>
                  </div>
                </div>
              </v-card-title>
              <v-card outlined v-if="sku && sku.content">

                <div class="d-flex align-center pa-2 mr-2">
                  <div>
                    <span class="font-weight-bold text-caption">{{ sku.content.name }}</span> <span
                      class="text-caption ml-2">({{ sku.content.size | bytes }})</span>
                    <div class="text-caption">{{ $t("order.gam.sendAt") }} {{ sku.content.dateSend | dateTimeS }}</div>
                    <!-- <div class="text-caption">{{ $t("order.gam.link") }}: <span>{{sku.content.gamLink}}</span> <a :href="sku.content.gamLink" target="_blank"><v-icon small>mdi-open-in-new</v-icon></a></div> -->
                    <div class="text-caption"><strong>Obs: </strong>
                      <p style="background: #f0f0f4; padding: 3px; border-radius: 3px" v-html="sku.content.obs"></p>
                    </div>
                  </div>
                  <SecureDownload @update-secure-link="sku.content.secureUrl = $event" :src="sku.content.url">
                  </SecureDownload>

                  <div class="d-flex">
                    <v-btn @click="approveContent(sku, skuIndex)"
                      :color="sku.content.status == 'content_reproved' ? 'grey' : 'success'"
                      :outlined="sku.content.status != 'content_approved'" elevation="0" class=" mr-2">{{
                        $t("order.approved") }}</v-btn>
                    <v-btn @click="sku.content.status = 'content_reproved'"
                      :color="sku.content.status == 'content_approved' ? 'grey' : 'error'"
                      :outlined="sku.content.status != 'content_reproved'" elevation="0">{{ $t("order.reproved")
                      }}</v-btn>
                  </div>
                </div>
                <div v-if="sku.content.status == 'content_reproved'" class="pa-2"><v-textarea outlined
                    v-model="sku.content.reason" :label="$t('order.reprovedReason')"></v-textarea></div>

              </v-card>
            </div>
          </v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="0" text @click="orderModal = false">
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn color="success" elevation="0" :disabled="!contentSaveEnabled || saving" @click="saveSkuStatus()"
              class="ml-2">{{ $t("common.save") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

    <v-dialog v-model="conclusion.show" width="540">
      <v-card class="mx-auto" v-if="conclusion.item">
        <v-card-title class="pb-5">{{ $t('order.gam.documents') }}</v-card-title>
        <v-card-subtitle class="pb-2"><v-icon x-small>mdi-pound</v-icon><span>{{ conclusion.item.id }}</span> <span
            class="ml-3 font-weight-bold">{{ conclusion.item.name }}</span></v-card-subtitle>
        <v-card-text>
          <v-card outlined class="pa-3">
            <h3>{{ $t('order.gam.documents') }}</h3>
            <!-- <v-row v-for="(file, i) in conclusion.item.files" :key="i">
              <v-col></v-col>
            </v-row> -->
            <!-- <v-btn @click="addFile(simulation, i)"
                  :color="simulation.content && simulation.content ? 'success' : 'primary'">Adicionar</v-btn> -->
            <FileUpload :unique="false" :snap="conclusion.item.files" :target="`campaign/files/${conclusion.item.id}`"
              :error="null" @set-upload="setConclusion(file.item, $event, 'files')"></FileUpload>
          </v-card>
          <v-card outlined class="pa-3">
            <h3>{{ $t('order.gam.invoices') }}</h3>

            <FileUpload :unique="false" :snap="conclusion.item.invoices"
              :target="`campaign/invoices/${conclusion.item.id}`" :error="null"
              @set-upload="setConclusion(file.item, $event, 'invoices')">
            </FileUpload>
          </v-card>
          <v-switch v-model="conclusion.complete"
            :label="conclusion.complete ? $t('order.gam.nomoreFilestoSend') : $t('order.gam.moreFilesToSendLater')"></v-switch>
          <div class="d-flex pt-3 mt-3">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="conclusion.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="saveFinalFiles()">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="file.show" width="540">
      <v-card class="mx-auto" v-if="file.item">
        <v-card-title class="pb-5">{{ $t('common.addContent') }}</v-card-title>
        <v-card-subtitle class="pb-2"><span class=" font-weight-bold">{{ file.item.asu.computed.formatText }}</span>
          <span class=" px-3">{{ file.item.asu.computed.coverageText }}</span><span class="">{{ file.item.asu.store
          }}</span></v-card-subtitle>
        <v-card-text>
          <div class="text-p font-weight-bold">{{ $t('order.gam.specifications') }}</div>
          <div class="text-caption pb-2" v-html="file.item.asu.specifications">

          </div>
          <FileUpload :unique="true" :snap="file.item.content" :target="`campaign/content/${file.item.id}`"
            :error="null" @set-upload="setFile(file.item, $event)"></FileUpload>
          <div class="d-flex pt-3 mt-3">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="file.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="applyFile(file.item)">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="files.show" width="540">
      <v-card class="mx-auto" v-if="files.item">
        <v-card-title class="pb-5">{{ $t('order.gam.contents') }}</v-card-title>
        <v-card-subtitle class="pb-2"><v-icon x-small>mdi-pound</v-icon><span>{{ files.item.id }}</span> <span
            class="ml-3 font-weight-bold">{{ files.item.name }}</span></v-card-subtitle>
        <v-card-text>
          <div v-for="(simulation, i) in files.item.simulation" :key="i">
            <v-row>
              <v-col>{{ simulation.asu.computed.formatText }} ({{ simulation.asu.computed.coverageText }}) - {{
                simulation.asu.store }}</v-col>
              <v-col>{{ simulation.asu.computed.coverageText }}</v-col>
              <v-col>{{ simulation.asu.store }}</v-col>
              <v-col><v-btn @click="addFile(simulation, i)"
                  :color="simulation.content && simulation.content ? 'success' : 'primary'">{{ $t('order.gam.content')
                  }}</v-btn></v-col>
            </v-row>
          </div>
          <!-- <FileUpload :snap="file.item[file.type]" :target="`campaign/invoices/${file.item.id}`" :error="null"
                              @set-upload="setFile(file.item, $event)"></FileUpload> -->
          <div class="d-flex pt-3 mt-3">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="saveFile(true)">{{ $t('order.gam.approveOrderWithoutContent') }}</v-btn>
            <v-btn class="mx-1" text @click="files.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="saveFile()">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="file.show" width="540">
      <v-card class="mx-auto" v-if="file.item">
        <v-card-title class="pb-5">{{ $t('common.addContent') }}</v-card-title>
        <v-card-subtitle class="pb-2"><span class=" font-weight-bold">{{ file.item.asu.computed.formatText }}</span>
          <span class=" px-3">{{ file.item.asu.computed.coverageText }}</span><span class="">{{ file.item.asu.store
          }}</span></v-card-subtitle>
        <v-card-text>
          <div class="text-p font-weight-bold">{{ $t('order.gam.specifications') }}</div>
          <div class="text-caption pb-2" v-html="file.item.asu.specifications">

          </div>
          <FileUpload :unique="true" :snap="file.item.content" :target="`campaign/content/${file.item.id}`"
            :error="null" @set-upload="setFile(file.item, $event)"></FileUpload>
          <div class="d-flex pt-3 mt-3">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="file.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="applyFile(file.item)">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="done.show" width="540">
      <v-card class="mx-auto">
        <v-card-title class="pb-5">{{ $t('sales.done.title') }}</v-card-title>

        <v-card-text>
          <div v-html="$t('sales.done.text', { confirm: $t('sales.done.confirm') })"></div>
          <v-text-field v-model="done.text" outlined></v-text-field>
          <div class="d-flex pt-3 mt-3">
            <v-btn color="primary" outlined @click="openConclusion(this.done.item)">{{ $t('order.gam.sendMoreFiles')
              }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="file.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="finishCampaign()" :loading="done.loading"
              :disabled="done.text != $t('sales.done.confirm')">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancel.show" width="540">
      <v-card class="mx-auto">
        <v-card-title class="pb-5">{{ $t('sales.cancel.title') }}</v-card-title>

        <v-card-text>
          <div v-html="$t('sales.cancel.text', { confirm: $t('sales.cancel.confirm') })"></div>
          <v-text-field v-model="cancel.text" outlined>
            <template v-slot:append>
              <v-icon color="success" v-if="cancel.text == $t('sales.cancel.confirm')">mdi-check</v-icon>
            </template>
          </v-text-field>

          <v-textarea outlined v-model="cancel.reason" :label="$t('sales.cancel.reason')"></v-textarea>
          <div class="d-flex pt-3 mt-3">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" text @click="cancel.show = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="success" elevation="0" @click="cancelOrderConfirm()" :loading="cancel.loading"
              :disabled="cancel.text != $t('sales.cancel.confirm') || !cancel.reason">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calendar.show" max-width="1440">
      <v-card class="mx-auto">
        <v-card-title>{{ $t('common.placementSchedule') }} <small class="ml-2">{{ calendar && calendar.order ?
          calendar.order.name : '' }}<v-icon class="ml-1" small color="#000">mdi-pound</v-icon>{{ calendar &&
              calendar.order ? calendar.order.id : '' }} </small> <small><a class="mx-2"
              v-if="calendar && calendar.order && this.masterStore.integrations && this.masterStore.integrations.googleAdManager && this.masterStore.integrations.googleAdManager.enabled"
              :href="`https://admanager.google.com/84748259#delivery/order/order_overview/order_id=${calendar.order.gamOrderId}`"
              target="_blank">{{ $t('order.gam.openInAdManager') }}</a></small></v-card-title>
        <v-card-text v-if="calendar.show">
          <GanttView :callback="saveSchedule" :headers="filterGantt.columns" @show="calendar.show = !$event"
            :snap="documentsGantt" :query-text="filterGantt.q" :dates="filterGantt.dates" :types="columns"></GanttView>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="formUpdateOrder.show" width="1280">
      <v-card class="mx-auto" v-if="formUpdateOrder.show">
        <v-card-title>Editar pedido</v-card-title>
        <v-card-text>
          <v-text-field label="ID do pedido" v-model="formUpdateOrder.item.id" disabled></v-text-field>
          <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
        >{{ formUpdateOrder.form.customExpirationDate | date }}</v-btn>
      </template>
      <v-date-picker label="Customize a data de vencimento do boleto" v-model="formUpdateOrder.form.customExpirationDate"></v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import moment from "moment";
import config from "@/store/config";
import VueJsonToCsv from "vue-json-to-csv";
import GanttView from '@/interface/GanttView.vue'
import { mapGetters, mapActions, mapState } from "vuex";
import SecureDownload from './SecureDownload'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";
import axios from "axios";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import FileUpload from '@/interface/FileUpload.vue'

export default {
  name: "OrdersList",
  components: {
    SecureDownload,
    FileUpload,
    VueJsonToCsv,
    GanttView
  },
  data: () => ({
    hasCustomExpirationDate: false,
    formUpdateOrder: {
      item: {},
      show: false,
      showPicker: false,
      form: {}
    },
    totals: {
      total: 0,
      discount: 0,
      policyDiscount: 0,
      final: 0
    },
    filteredLogs: [],
    itemRowIndex: 0,
    snapSearch: null,
    loaded: false,
    updateLog: 0,
    calendar: {
      show: false,
      order: null
    },
    cancel: {
      show: false,
      id: null,
      text: "",
      reason: "",
      loading: false
    },
    readyDoc: false,
    done: {
      id: null,
      text: "",
      item: null,
      loading: false,
      show: false
    },
    file: {
      index: null,
      type: null,
      show: false,
      item: null
    },
    files: {
      item: null,
      show: false
    },
    conclusion: {
      item: null,
      complete: false,
      show: false
    },
    saving: false,
    activeColumns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12,13],
    setCalendar: -1,
    filter: {
      date: {
        menu: false,
        dates: [
          moment().subtract(1, "month").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      }
    },
    steps: {
      intention: ['intention'],
      planning: ['planning'],
      checkout: ['waiting_payment', 'waiting_quotation', 'payment', 'processing', 'overdue_payment'],
      payment: ['content', 'paid', 'content_reproved', 'content_approved', 'awaiting_content_approval', 'waiting_content', 'waiting_pi_approval', 'content_partially_reproved', 'refused', 'refunded', 'chargeback', 'chargedback', 'canceled', 'pending_refund', 'partial_refund', 'overpaid', 'underpaid'],
      placement: ['placement', 'waiting_placement', 'on_placement', 'placement_error'],
      finish: ['finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement']
    },
    columns: [
      { index: 0, name: "store", fixed: false, type: 'text' },
      { index: 1, name: "media", fixed: false, type: 'text' },
      { index: 2, name: "title", fixed: false, type: 'text' },
      { index: 3, name: "bucket", fixed: false, type: 'text' },
      { index: 4, name: 'spacer', fixed: false, type: 'spacer' },
      { index: 5, name: "insertions", fixed: false, type: 'text' },
      // { index: 7, name: "unityPrice", fixed: false, type: 'currency' },
      { index: 6, name: "discount", fixed: false, type: 'text' },
      { index: 6, name: "couponDiscount", fixed: false, type: 'text' },
      // { index: 9, name: "price", fixed: false, type: 'currency' },
      { index: 7, name: "totalPrice", fixed: false, type: 'currency' },
      { index: 8, name: "location", fixed: false, type: 'text' },
      { index: 9, name: "coverage", fixed: false, type: 'text' },
      { index: 10, name: "total", fixed: false, type: 'text' },
      { index: 11, name: "gam", fixed: false, type: 'text' }

    ],
    newDates: [],
    disapprovedModal: false,
    status: [],
    statusGroup: 0,
    search: "",
    toExport: [],
    loading: true,
    documents: [],
    orderModal: false,
    orderSkus: null,
    docSkell: null,
  }),
  props: {
    loadingLog: Boolean,
    accounts: {
      type: Array,
    },
    log: {
      type: [Array, Object]
    }
  },
  computed: {
    ...mapState("groupStores", [
      "allStores",
      "masterStore",
      "subStores",
      "selectedStore",
    ]),
    documentsGantt() {
      if (!this.calendar.order) return []
      const result = []
      let i = 0;
      this.calendar.order.simulation.forEach((simulation) => {
        const buckets = []
        simulation.asu.buckets.forEach((bucket) => {
          buckets.push(`${bucket.title}: ${bucket.name}`)
        })
        const store = this.allStores.find(st => st.id == simulation.asu.store)
        const line = {
          id: i++,
          info: {
            asuId: simulation.asu.id,
            store: store.name,
            productIndex: simulation.productIndex,
            title: simulation.asu.computed.formatText,
            media: simulation.asu.computed.mediaType.text,
            bucket: buckets.join(', '),
            location: simulation.asu.computed.locationsText,
            coverage: simulation.asu.computed.coverageText,
            spacer: '',
            insertions: simulation.total.totalSum,
            unityPrice: simulation.asu.rules.pricing.unityPrice,
            discount: `${this.$n(simulation.asu.rules.pricing.discount, 'currency')} (${this.$n(simulation.asu.computed.discount)}%)`,
            price: simulation.asu.rules.pricing.price,
            totalPrice: simulation.asu.rules.pricing.price * simulation.total.totalSum,
            gam: simulation.gamLineItem
          },
          group: true,
          meta: {
            pack: simulation.pack,
            group: simulation.group,
          },
          color: '#000',
          selected: simulation.total.filled
        }
        console.log('Line...', line)
        result.push(line)
      })
      return result
    },
    range() {
      const result = { first: null, last: null };
      const simulations = this.calendar.order.simulation
      simulations.forEach((simulation) => {
        simulation.total.selected.forEach((date) => {
          const key = moment(`${date.year}-${date.month}-${date.monthDay}`, "YYYY-M-DD");
          if (!result.first || moment(result.first).isAfter(key)) {
            result.first = key.format("YYYY-MM-DD");
          }
          if (!result.last || moment(result.last).isBefore(key)) {
            result.last = key.format("YYYY-MM-DD");
          }
        });
      });
      console.log('result', result)
      return result;
    },

    filterGantt() {
      if (!this.calendar.order) return []
      console.log('range ...x', this.range)
      const res = {
        q: "",
        pp: 10,
        dates: [
          moment(this.range.first, 'YYYY-MM-DD').subtract(3, 'days').format('YYYY-MM-DD'),
          moment(this.range.last, 'YYYY-MM-DD').add(3, 'days').format('YYYY-MM-DD')
        ],
        columns: [this.columns[0], this.columns[1], this.columns[2], this.columns[3], this.columns[10]],
        details: [this.columns[0], this.columns[1], this.columns[2], this.columns[3], this.columns[10]]
      }
      if (['waiting_payment', 'processing'].includes(this.calendar.order.status)) {
        res.details = res.details.concat([this.columns[4], this.columns[5], this.columns[6], this.columns[8]])
      }

      res.columns.push(this.columns[9])
      res.columns.push(this.columns[11])
      res.details.push(this.columns[9])
      res.details.push(this.columns[11])

      return res
    },
    // filteredLogs() {
    //   let dates = [];
    //   if (this.filter.date.dates.length == 2)
    //     if (moment(this.filter.date.dates[0]).isBefore(this.filter.date.dates[1])) {
    //       dates = [this.filter.date.dates[0], this.filter.date.dates[1]];
    //     }
    //     else {
    //       dates = [this.filter.date.dates[1], this.filter.date.dates[0]];
    //     }
    //   if (this.filter.date.dates.length == 1) {
    //     dates = [this.filter.date.dates[0], this.filter.date.dates[0]];
    //   }

    //   const res = []
    //   const logs = this.log
    //   logs.forEach((l) => {
    //     if (moment(l.date).isBetween(dates[0], `${dates[1]} 23:59:59`)) {
    //       res.push(l)
    //     }

    //   })
    //   return res
    // },
    csvLabels() {
      return {
        id: { title: "ID" },
        itemName: { title: "Formato" },
        itemTotalPrice: { title: "Total do formato" },
        itemTotalDiscount: { title: "Desconto" },
        itemFinalPrice: { title: "Valor final" },
        itemInsertions: { title: "Inserções do item" },
        insertions: { title: "Inserções" },
        customer: { title: "Cliente" },
        userName: { title: "Nome" },
        userId: { title: "ID  do cliente" },
        createdOn: { title: "Data do pedido" },
        updatedOn: { title: "Atualização do pedido" },
        name: { title: "Nome da campanha" },
        status: { title: "Status" },
        total: { title: "Total" },
        discount: { title: "Desconto base" },
        policyDiscount: { title: "Desconto por volume" },
        couponDiscount: { title: "Cupon de desconto"},
        final: { title: "Valor final" }
      }
    },
    computedDateFormatted() {
      return moment().format("YYYY-MM-DD HH mm");
    },
    contentSaveEnabled() {
      let complete = true;
      if (!this.orderModal)
        return false
      if (!this.orderSkus || !this.orderSkus.simulation)
        return false;
      const allSkus = this.orderSkus.simulation;
      allSkus.forEach((sku) => {
        if (sku.content && sku.content.status == 'awaiting_content_approval') {
          complete = false;
        }
      });
      return complete;
    },
    headers() {
      const res = [];
      this.allColumns.forEach((column, i) => {
        if (this.activeColumns.includes(i) && ((this.status.length && this.status[0] != 'intention') || (this.status[0] == 'intention' && column.value != 'computed.userName'))) {
          res.push(column);
        }
      });
      res.push({
        text: "",
        align: "end",
        sortable: true,
        value: "actions"
      },);
      return res;
    },
    allColumns() {
      return [
        { text: "ID", value: "id", index: 0 },
        {
          text: this.$t("sales.ordersList.campaign"),
          align: "start",
          sortable: true,
          value: "name",
          index: 1
        },
        {
          text: 'Items',
          align: 'start',
          sortable: false,
          value: 'packages',
          index: 2,
        },
        {
          text: this.$t("sales.ordersList.client"),
          align: "start",
          sortable: true,
          value: "client",
          index: 3
        },
        {
          text: this.$t("sales.ordersList.user"),
          align: "start",
          sortable: true,
          value: "computed.userName",
          index: 4
        },
        {
          text: this.$t("sales.ordersList.creatAt"),
          align: "start",
          sortable: true,
          value: "createdOnX",
          index: 5
        },
        {
          text: this.$t("sales.ordersList.updatedOn"),
          align: "start",
          sortable: true,
          value: "updatedOnX",
          index: 6
        },
        {
          text: 'Período de veiculação',
          align: 'start',
          sortable: true,
          value: 'range',
          index: 7
        },
        {
          text: this.$t("sales.ordersList.status"),
          align: "start",
          sortable: true,
          value: "status",
          index: 8
        },
        {
          text: this.$t("sales.ordersList.total"),
          align: "start",
          sortable: true,
          value: "total.total",
          index: 9
        },
        {
          text: this.$t("sales.ordersList.discount"),
          align: "start",
          sortable: true,
          value: "total.discount",
          index: 10
        },
        {
          text: this.$t("sales.ordersList.couponDiscount"),
          align: "start",
          sortable: true,
          value: "total.couponDiscount",
          index: 11
        },
        {
          text: this.$t("sales.ordersList.policyDiscount"),
          align: "start",
          sortable: true,
          value: "total.policyDiscount",
          index: 12
        },
        {
          text: this.$t("sales.ordersList.final"),
          align: "start",
          sortable: true,
          value: "total.final",
          index: 13
        },
      ];
    },
    // getOrderSkus() {
    //   if (!this.$route.params || !this.orderSkus) {
    //     return []; // Retorna null ou outro valor padrão quando $route.params não existe
    //   }
    //   console.log('getParmas', this.$route.params.id);
    //   let filterDocs = this.documents.filter((item) => item.id == this.$route.params.id);
    //   console.log('filterDocs', filterDocs);
    //   return filterDocs && filterDocs.length ? filterDocs[0] : [];
    // },
    dateRangeText() {
      let datesSelected = this.filter.date.dates;
      if (!datesSelected.length)
        return "";
      if (this.filter.date.dates.length == 2) {
        if (moment(this.filter.date.dates[0]).isBefore(this.filter.date.dates[1])) {
          datesSelected = [
            this.filter.date.dates[0],
            this.filter.date.dates[1],
          ];
        }
        else {
          datesSelected = [
            this.filter.date.dates[1],
            this.filter.date.dates[0],
          ];
        }
      }
      const dates = datesSelected.length
        ? [moment(datesSelected[0], "YYYY-MM-DD").format("L")]
        : [];
      if (datesSelected.length == 2)
        dates.push(moment(datesSelected[1], "YYYY-MM-DD").format("L"));
      if (datesSelected.length == 1)
        dates.push(moment(datesSelected[0], "YYYY-MM-DD").format("L"));
      return dates.join(" to ");
    }
  },
  watch: {
    // "$route.params"(value) {
    //   this.updateOrderSkus();
    //   if (value.id) {
    //     console.log("this.$route.params.id", this.$route.params);
    //     //this.orderModal = true;
    //   }
    // },
    'snapSearch'(value) {
      if (!value) {
        this.$router.push(`/sales/orders?status=${this.$route.query.status}`)
        setTimeout(() => {
          this.loadDocuments()
        }, 100)
      }
    },
    'search'(value) {
      if (!this.loaded) {
        this.snapSearch = value
      }
    },
    'file.show'(value) {
      if (value == false)
        this.file.item = null
      this.file.type = null
    },
    'conclusion.show'(value) {
      if (!value) {
        this.conclusion.item = null
        this.conclusion.complete = false
      }
    },
    'statusGroup': {
      deep: true,
      handler(v) {
        console.log('V', v)
        if (v == 0) {
          this.status = ['intention']
          this.updateLog++
          console.log('updating log', this.updateLog)
          this.$emit('update-logs', this.updateLog)
        }
        if (v == 1) this.status = this.steps.planning
        if (v == 2) this.status = this.steps.checkout
        if (v == 3) this.status = this.steps.payment
        if (v == 4) this.status = this.steps.placement
        if (v == 5) this.status = this.steps.finish


      }
    },

    // getOrderSkus(nv) {
    //   console.log('nv getOrder SKUS', nv)
    //   if (nv && nv.length && this.$route.params.id) {
    //     this.orderSkus = nv
    //     this.orderModal = true;
    //     console.log('tem', this.orderSkus);
    //   }
    // },
    orderModal(nv) {
      if (!nv && this.readyDoc) {
        console.log('removing id')
        delete this.$route.params.id
        console.log("modal closed", this.$route.query);
        // setTimeout(() => {
        //   this.$router.replace(`/sales/orders/?status=${this.$route.query.status}`);
        // }, 100)
      }

    },
    status: {
      deep: true,
      handler(v) {
        console.log('V-status', v)
        // if(!this.readyDoc){

        // let status = this.$route.query.status
        let query = this.$route.params.id ? `/sales/orders/${this.$route.params.id}` : `/sales/orders/`
        if (!this.loaded) {
          this.loaded = true
        }
        else {
          if (this.snapSearch == this.search) {
            this.search = ""
          }
          query = `/sales/orders/`
        }
        if (v.includes('intention')) {
          if (this.$route.query.status != 'intention')
            this.$router.replace(`${query}?status=intention`)
        }

        if (v.includes('planning')) {
          if (this.$route.query.status != 'planning')
            this.$router.replace(`${query}?status=planning`)
        }
        if (v.includes('waiting_payment') || v.includes('processing')) {
          if (this.$route.query.status != 'checkout')
            this.$router.replace(`${query}?status=checkout`)
        }
        if (v.includes('paid')) {
          if (this.$route.query.status != 'payment')
            this.$router.replace(`${query}?status=payment`)
        }
        if (v.includes('waiting_placement')) {
          if (this.$route.query.status != 'placement')
            this.$router.replace(`${query}?status=placement`)
        }
        if (v.includes('done')) {
          if (this.$route.query.status != 'finish')
            this.$router.replace(`${query}?status=finish`)
        }
        setTimeout(() => {
          if (!v.includes('intention'))
            this.loadDocuments()
          else
            this.formatLogsToExport()
        })
        // }

      },
    },
    "filter.date.dates": {
      deep: true,
      handler() {
        if (this.$route.query.status != 'intention')
          this.loadDocuments();
        else {
          this.loadLogs()
        }
      },
    },
    'log': {
      deep: true,
      handler() {
        if (this.$route.query.status == 'intention') {
          this.loadLogs()
        }
      }
    },
    "filter.date.menu": {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.newDates = JSON.parse(JSON.stringify(this.filter.date.dates));
          }, 100);
        }
      },
    },
  },
  created() {
    const dates = [
      moment().subtract(1, "month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ];


    if (this.$route.query.from) {
      dates[0] = this.$route.query.from;
    }
    if (this.$route.query.to) {
      dates[1] = this.$route.query.to;
    }
    this.filter.date.dates = dates;






  },
  mounted() {
    // if (this.$route.params.id) {
    //   this.updateOrderSkus();
    // }
    if (!this.$route.query.hasOwnProperty("id")) {
      this.$route.query.id = null;
    }
    //console.log("mountedParams", this.$route.params.id);
    if (this.$route.params.id) {
      this.snapSearch = this.$route.params.id
      //this.orderModal = true;
    }
    else {
      const status = this.$route.query.status ? this.$route.query.status : 'payment'
      this.status = this.steps[status]
      if (status) {
        switch (status) {
          case 'intention':
            this.statusGroup = 0
            break;
          case 'planning':
            this.statusGroup = 1
            break;
          case 'checkout':
            this.statusGroup = 2
            break;
          case 'payment':
            this.statusGroup = 3
            break;
          case 'placement':
            this.statusGroup = 4
            break;
          case 'finish':
            this.statusGroup = 5
            break;

        }
      }
    }

  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    approveContent(sku, index) {
      console.log('Sku', sku)
      this.orderSkus.simulation[index].content.status = 'content_approved'
      this.orderSkus.simulation[index].content.dateApproval = moment().format()
    },
    loadLogs() {
      console.log('init load logs')
      let dates = [];
      if (this.filter.date.dates.length == 2)
        if (moment(this.filter.date.dates[0]).isBefore(this.filter.date.dates[1])) {
          dates = [this.filter.date.dates[0], this.filter.date.dates[1]];
        }
        else {
          dates = [this.filter.date.dates[1], this.filter.date.dates[0]];
        }
      if (this.filter.date.dates.length == 1) {
        dates = [this.filter.date.dates[0], this.filter.date.dates[0]];
      }

      const res = []
      const logs = this.log
      const from = moment(`${dates[0]} 00:00:00`, 'YYYY-MM-DD HH:mm:ss')
      const to = moment(`${dates[1]} 23:59:59 HH:mm:ss`, 'YYYY-MM-DD HH:mm:ss')
      logs.forEach((l) => {
        if (moment(l.date).isBetween(from, to)) {
          res.push(l)
        }

      })
      this.filteredLogs = res
      this.formatLogsToExport()
    },
    formatLogsToExport() {
      const c = {}
      const toExport = []
      console.log('this', this.log)
      this.log.forEach((data, i) => {
        const dataItem = {}
        if (!c.hasOwnProperty(data.id)) {
          c[data.id] = 0
        }
        c[data.id]++
        // dataItem.id = c[data.id] == 1 ? data.id : data.id + ' (' + c[data.id] + ')'
        dataItem.id = data.id
        dataItem.itemName = data.itemDetails.name
        dataItem.itemTotalPrice = this.$n(data.itemDetails.price, 'currency')
        dataItem.itemTotalDiscount = 0
        dataItem.itemFinalPrice = 0
        dataItem.itemInsertions = 0
        dataItem.insertions = 0
        dataItem.userName = data.user && data.user.displayName ? data.user.displayName : '',
          dataItem.customer = data.user && data.user.company ? data.user.company : '',
          dataItem.userId = data.user && data.user.uid ? data.user.uid : '',
          dataItem.createdOn = data.date
        dataItem.updatedOn = null
        dataItem.name = data.orderName
        dataItem.status = 'Inteción'
        dataItem.total = this.$n(data.itemDetails.price, 'currency')
        dataItem.discount = null
        dataItem.finalWithoutPolicy = ''
        dataItem.policyDiscount = ''
        dataItem.final = ''
        toExport.push(dataItem)
      })
      this.toExport = toExport
    },
    saveSchedule(item) {
      console.log('Item', item)
      const orderId = this.calendar.order.id
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "orders"), where("id", "==", orderId));
      const querySnapshot = getDocs(q);
      querySnapshot.then((docs) => {
        if (!docs.empty) {
          const orderDoc = docs.docs[0];
          const orderData = orderDoc.data();
          console.log('orderData', orderData)
          const result = { start: null, end: null }
          const simulations = orderData.simulation
          simulations.forEach((simulation) => {
            const foundSimulation = item.find(item => item.meta.group == simulation.group && item.info.productIndex == simulation.productIndex)
            if (foundSimulation) {
              const currentSelected = foundSimulation.selected
              simulation.total.selected = currentSelected

              foundSimulation.selected.forEach((s) => {
                let k = moment(`${s.year}-${s.month}-${s.monthDay}`, 'YYYY-M-D')
                if (!result.start) {
                  result.start = k
                  result.end = k
                }
                else {
                  if (result.start.isAfter(k)) {
                    result.start = k
                  }
                  if (result.end.isBefore(k)) {
                    result.end = k
                  }
                }
              })
            }
          })
          if (result.start) {
            result.start = result.start.format('YYYY-MM-DD')
            result.end = result.end.format('YYYY-MM-DD')
          }
          orderData.range = result

          const orderRef = doc(db, "orders", orderId);
          if (!orderData.hasOwnProperty('log')) {
            orderData.log = []
          }
          orderData.log.push({
            action: 'scheduleUpdated',
            by: this.$root.auth.user.uid,
            date: moment().format()
          })
          const Form = {
            log: orderData.log,
            range: orderData.range,
            simulation: orderData.simulation,
            updatedOn: moment().format()
          }


          updateDoc(orderRef, Form).then(() => {
            this.showSnack({
              text: this.$t('sales.ordersList.modalPlacement.confirm.updated'),
              color: "success",
              timeout: 4000,
              icon: "mdi-check",
            });
            this.calendar.show = false
            this.loadDocuments()
          })

        }
      })
    },
    editCalendar(item) {
      this.calendar.order = item
      this.calendar.show = true
    },
    cancelOrderConfirm() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const orderRef = doc(db, "orders", this.cancel.id);

      const Form = {
        status: 'canceled',
        cancelReason: this.cancel.reason,
        updatedOn: moment().format(),
        canceledOn: moment().format()
      }
      updateDoc(orderRef, Form).then(() => {
        this.cancel = {
          show: false,
          id: null,
          text: "",
          reason: "",
          loading: false
        }
        if (this.$route.query.status != 'intention')
          this.loadDocuments()
      })
    },
    cancelOrder(item) {
      this.cancel.id = item.id
      this.cancel.show = true
    },
    openFiles(item) {
      this.files.show = true
      this.files.item = item
    },
    openConclusion(item) {
      if (!item.hasOwnProperty('invoices')) {
        item.invoices = []
      }
      if (!item.hasOwnProperty('files')) {
        item.files = []
      }
      this.conclusion.item = item
      setTimeout(() => {
        this.conclusion.show = true
      }, 100)
    },
    addFile(item, i, type = 'content') {
      if (item.hasOwnProperty('content') && item.content) {
        // let list = []
        // item.content.forEach((content) => {
        //   list.push(content.info)
        // })
        // item.content = [item.content]
      }
      this.file.item = JSON.parse(JSON.stringify(item))
      this.file.index = i
      this.file.show = true
      this.file.type = type
    },
    saveFile(onlyConfirmWithoutContent = false) {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const orderRef = doc(db, "orders", this.files.item.id);
      let status = this.files.item.status
      let sum = 0
      let simulationStatus = 'waiting_content'
      if (!onlyConfirmWithoutContent) {

        this.files.item.simulation.forEach((simulation) => {
          if (simulation.hasOwnProperty('content') && simulation.content) {
            if (simulation.content.url) {
              status = 'awaiting_content_approval'
              simulationStatus = 'awaiting_content_approval'
            }
            else {
              console.log('Simulation.content.length', simulation.content)
              if (simulation.content.length) {
                simulation.content = simulation.content[0]
                status = 'awaiting_content_approval'
              }
            }

          }
          else {
            simulation.content = null
          }
        })
        const updateObject = {
          simulation: this.files.item.simulation,
          status: status
        }

        console.log('updateObject', updateObject)
        updateDoc(orderRef, updateObject).then(() => {
          this.files.type = null
          this.files.item = null
          this.files.show = false
          this.showSnack({
            text: this.$t("sales.ordersList.orderUpdated"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
          if (this.$route.query.status != 'intention')
            this.loadDocuments()
        })
      }
      else {
        status = 'waiting_pi_approval'
        updateDoc(orderRef, { status: status, updatedOn: moment().format() }).then(() => {
          this.files.type = null
          this.files.item = null
          this.files.show = false
          this.showSnack({
            text: this.$t("sales.ordersList.orderUpdated"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
          if (this.$route.query.status != 'intention')
            this.loadDocuments()
        });
      }


    },
    saveFinalFiles() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const orderRef = doc(db, "orders", this.conclusion.item.id);
      if (this.conclusion.complete) {
        this.conclusion.item.status = 'documents_sent'
      }
      const form = {
        status: this.conclusion.item.status,
        updatedOn: moment().format(),
        files: this.conclusion.item.files,
        invoices: this.conclusion.item.invoices
      }
      console.log('form to save', form)
      updateDoc(orderRef, form).then(() => {
        this.showSnack({
          text: this.$t("sales.ordersList.orderUpdated"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        this.conclusion.show = false
      });


    },
    finishCampaign() {
      this.done.loading = true
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const orderRef = doc(db, "orders", this.done.id);

      updateDoc(orderRef, { status: 'done' }).then(() => {
        this.done.loading = false
        this.done.type = null
        this.done.item = null
        this.done.show = false
        this.showSnack({
          text: this.$t("sales.done.finish"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        if (this.$route.query.status != 'intention')
          this.loadDocuments()
      });

    },
    cancelFile() {
      this.file.show = false
    },
    setFile(file, e) {
      console.log("FILE", file)
      console.log("event", e)
      if (!this.file.item.hasOwnProperty('content')) {
        this.file.item.content = null
      }
      let res = []
      e.forEach((file) => {
        file.type = file.extension
        res.push({ ...file, url: file.url, dateSend: moment().format(), reason: '', dateApproval: null, status: 'waiting_approval' })
      })
      this.file.item.content = res

    },
    setConclusion(file, e, target) {
      console.log("FILE", file)
      console.log("event", e)
      if (!this.conclusion.item.hasOwnProperty(target)) {
        this.conclusion.item[target] = []
      }
      let res = []
      e.forEach((file) => {
        file.type = file.extension
        res.push({ ...file, url: file.url, dateSend: moment().format(), reason: '' })
      })
      this.conclusion.item[target] = res
    },
    applyFile() {

      if (!this.files.item.simulation[this.file.index].hasOwnProperty('content')) {
        this.files.item.simulation[this.file.index].content = []
      }
      this.files.item.simulation[this.file.index].content = this.file.item.content
      this.file.show = false
    },
    getStoreName(id) {
      const lookingFor = this.allStores.find(store => store.id == id);
      if (lookingFor)
        return lookingFor.name;
      return null;
    },
    async saveSkuStatus() {
      try {
        this.saving = true;
        let countError = 0;
        let complete = true;
        const allSkus = this.orderSkus.simulation;
        allSkus.forEach((sku) => {
          if (sku.content && sku.content.status == 'content_reproved') {
            countError++;
            complete = false;
          }
        });
        const orderId = this.$route.params.id || this.orderSkus.id;
        // Buscar o documento na coleção de pedidos
        const db = getFirestore();
        const ordersCollection = collection(db, "orders");
        const ordersQuery = query(ordersCollection, where("id", "==", orderId));
        const querySnapshot = await getDocs(ordersQuery);
        if (!querySnapshot.empty) {
          const orderDoc = querySnapshot.docs[0];
          const orderData = orderDoc.data();
          orderData.simulation = this.orderSkus.simulation;
          orderData.status = complete ? (this.masterStore.options.contentBeforePayment ? "waiting_payment" : "waiting_pi_approval") : (allSkus.length == countError ? 'content_reproved' : 'content_partially_reproved');
          orderData.updatedOn = moment().format();
          console.log('orderData', orderData);
          const orderRef = doc(db, "orders", orderDoc.id);
          await setDoc(orderRef, orderData);
          setTimeout(() => {
            this.orderModal = false;
            if (this.$route.query.status != 'intention')
              this.loadDocuments();
            else
              this.formatLogsToExport()
            this.saving = false;
          }, 1000);
          console.log("Documento atualizado com sucesso!");
        }
        else {
          this.saving = false;
          console.log("Documento não encontrado.");
        }
      }
      catch (error) {
        this.saving = false;
        console.error("Ocorreu um erro ao salvar o pedido:", error);
      }
    },
    cancelSkuModal() {
      this.documents = this.docSkell;
      this.orderModal = false;
    },
    disapprovedContent(sku) {
      sku.asu.status = "content_reproved";
      console.log("status_Sku:", sku.asu.status);
      console.log("orderSkus:", this.orderSkus);
    },
    approvalContent(sku) {
      sku.asu.status = "content_approved";
      console.log("status_Sku:", sku.asu.status);
      console.log("orderSkus:", this.orderSkus);
    },
    // updateOrderSkus() {
    //   this.orderSkus = this.getOrderSkus; // Atribui o valor retornado pela computed property à variável orderSkus no data
    // },
    downloadContent(file) {
      const url = file;
      this.$axios({
        url: url,
        method: "GET",
        responseType: "blob", // Define a resposta como um objeto Blob
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "imagem.jpg");
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    openSkus(item) {
      // this.$router.replace(`/sales/orders/${item.id}?status=${this.$route.query.status}`);
      if (['waiting_content', 'content_approved', 'awaiting_content_approval', 'content_reproved', 'content_partially_reproved'].includes(item.status)) {
        this.orderSkus = item
        this.orderModal = true
      }

      if (['paid'].includes(item.status)) {
        this.openFiles(item, 'content')
      }
      if (['documents_sent'].includes(item.status)) {
        this.done.id = item.id
        this.done.item = item
        this.done.text = ''
        this.done.show = true
      }
      if (['finish_placement'].includes(item.status)) {
        this.openConclusion(item)
      }
      if(['checkout', 'planning'].includes(item.status)){
        this.formUpdateOrder.item = item
        this.hasCustomExpirationDate = false
        this.formUpdateOrder.form = {
          customExpirationDate: moment().add(2, 'days').format('YYYY-MM-DD')
        }
        this.formUpdateOrder.show = true
      }

      // console.log('id',id)
    },
    applyDate(fixedDays = 0) {
      // igual a 0? recebe o valor dos dias selecionados no filtro
      console.log("fixed", fixedDays);
      this.setCalendar = fixedDays; // pega esse valor e aplica na var setCalendar
      if (fixedDays) {
        // se o parametro existir
        const start = moment().format("YYYY-MM-DD"); // define uma var start como a data atual
        console.log("start", start);
        //define a var newDates([0]) como a data atual mais as horas min e sec e subtrai o valor passado por parametro -1(retira hj) em dias e formata para yyyy-mm-dd
        this.newDates[0] = moment(`${start} 00:00:00`, "YYYY-MM-DD HH:mm:ss")
          .subtract(fixedDays - 1, "days")
          .format("YYYY-MM-DD");
        this.newDates[1] = moment().format("YYYY-MM-DD"); // Define a var newDats([1]) como a data de hoje
      }
      if (fixedDays == -1) {
        this.filter.date.dates = ['2023-06-01', moment().format('YYYY-MM-DD')]
      }
      else {
        const dates = JSON.parse(JSON.stringify(this.newDates)); // da um parse para transforma a string em objeto e depois transforma em string dnv
        this.filter.date.dates = moment(dates[0]).isBefore(dates[1])
          ? [dates[0], dates[1]]
          : [dates[1], dates[0]]; //Verifica se o newDates [0] vem antes do [1] e ajusta
        this.filter.date.menu = false;
      }
    },
    // applyDate() {
    //     this.$refs.menu.save(this.filter.date.dates)
    //     this.loadDocuments()
    // },
    loadDocuments() {
      // to do ORDER dates
      let totals = {
        total: 0,
        discount: 0,
        couponDiscount: 0,
        policyDiscount: 0,
        final: 0
      }
      this.totals = totals

      this.loading = true;
      let dates = [];
      if (this.filter.date.dates.length == 2)
        if (this.filter.date.dates[0] == '') {

        }
        else {
          if (moment(this.filter.date.dates[0]).isBefore(this.filter.date.dates[1])) {
            dates = [this.filter.date.dates[0], this.filter.date.dates[1]];
          }
          else {
            dates = [this.filter.date.dates[1], this.filter.date.dates[0]];
          }
        }
      if (this.filter.date.dates.length == 1) {
        dates = [this.filter.date.dates[0], this.filter.date.dates[0]];
      }
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const queries = this.$route.params.id ? ["id", "==", this.$route.params.id] : [
        "status", "!=", "plan"
      ]
      const q = query(collection(db, "orders"), where(queries[0], queries[1], queries[2]));
      const querySnapshot = getDocs(q);
      const documents = [];
      const toExport = []
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          let total = 0;
          // let storeIncludes = null;
          const data = doc.data();
          if (this.status.includes(data.status) || (this.$route.params.id && doc.id == this.$route.params.id)) {


            // let partOrder = JSON.parse(JSON.stringify(data));
            if (data.simulation.length && (moment(data.updatedOn).isBetween(dates[0], `${dates[1]} 23:59:59`) || this.filter.date.dates[0] == '')) {
              // const simulationConst = data.simulation;
              // simulationConst.forEach((simulation) => {
              // if (!this.$root.auth.profile.whitelabelId || simulation.asu.store == this.$root.auth.profile.whitelabelId) {
              //   if (!partOrder.hasOwnProperty('_simulations')) {
              //     partOrder._simulations = [];
              //   }
              //   total++;
              //   storeIncludes = true;
              //   partOrder._simulations.push(simulation);
              // }
              // });
              const packs = []
              const packsKeys = []
              const user = data.user && Object.keys(data.user).length ? data.user : null;
              const computed = {
                simulationLength: data.simulation.length,
                createdOn: data.createdOn,
                userName: user ? user.displayName : null,
                userId: user ? user.uid : null,
              }
              

              let dataItem = {}
              data.simulation.forEach((simulation) => {
                if (!packsKeys.includes(simulation.group)) {
                  if (simulation.pack) {
                    packsKeys.push(simulation.group)
                    packs.push(simulation.pack)
                    dataItem.id = data.id
                    dataItem.itemName = simulation.pack.name
                    dataItem.itemTotalPrice = this.$n(simulation.pack.totalPrice, 'currency')
                    dataItem.itemTotalDiscount = this.$n(simulation.pack.totalDiscount, 'currency')
                    dataItem.itemFinalPrice = this.$n(simulation.pack.finalPrice, 'currency')
                    dataItem.itemInsertions = simulation.pack.insertions
                    dataItem.insertions = data.total ? data.total.insertions : 0
                    dataItem.userName = user && user.displayName ? user.displayName : '',
                      dataItem.customer = user && user.uid ? this.getClientName(user.uid) : '',
                      dataItem.userId = user && user.uid ? user.uid : '',
                      dataItem.createdOn = data && data.createdOn ? data.createdOn : '',
                      dataItem.updatedOn = data.updatedOn
                    dataItem.name = data.name
                    dataItem.status = this.$t(`whiteLabelStatus.${data.status}[0]`)
                    dataItem.total = this.$n(data.total ? data.total.total : 0, 'currency')
                    dataItem.discount = this.$n(data.total ? data.total.discount : 0, 'currency')
                    dataItem.finalWithoutPolicy = this.$n(data.total ? data.total.finalWithoutPolicy : 0, 'currency')
                    dataItem.policyDiscount = this.$n(data.total ? data.total.policyDiscount : 0, 'currency')
                    dataItem.couponDiscount = this.$n(data.total ? data.total.couponDiscount : 0, 'currency' )
                    dataItem.final = this.$n(data.total ? data.total.final : 0, 'currency')
                  }
                  else {
                    packs.push(simulation.asu)
                    dataItem.id = data.id
                    dataItem.itemName = simulation.name
                    dataItem.itemTotalPrice = this.$n(simulation.total.totalPrice, 'currency')
                    dataItem.itemTotalDiscount = this.$n(simulation.total.totalDiscount, 'currency')
                    dataItem.itemFinalPrice = this.$n(simulation.finalPrice, 'currency')
                    dataItem.itemInsertions = simulation.total.insertions
                    dataItem.insertions = data.total ? data.total.insertions : 0
                    dataItem.userName = user && user.displayName ? user.displayName : '',
                      dataItem.customer = user && user.uid ? this.getClientName(user.uid) : '',
                      dataItem.userId = user && user.uid ? user.uid : '',
                      dataItem.createdOn = data.createdOn
                    dataItem.updatedOn = data.updatedOn
                    dataItem.name = data.name
                    dataItem.status = this.$t(`whiteLabelStatus.${data.status}[0]`)
                    dataItem.total = this.$n(data.total ? data.total.total : 0, 'currency')
                    dataItem.discount = this.$n(data.total ? data.total.discount : 0, 'currency')
                    dataItem.finalWithoutPolicy = this.$n(data.total ? data.total.finalWithoutPolicy : 0, 'currency')
                    dataItem.policyDiscount = this.$n(data.total ? data.total.policyDiscount : 0, 'currency')
                    dataItem.couponDiscount = this.$n(data.total ? data.total.couponDiscount : 0, 'currency' )
                    dataItem.final = this.$n(data.total ? data.total.final : 0, 'currency')
                  }



                  toExport.push(dataItem)
                }
              })

              
              totals.total += data.total ? data.total.total : 0
              totals.discount += data.total ? parseFloat(data.total.discount) : 0
              totals.policyDiscount += data.total ? data.total.policyDiscount : 0
              totals.couponDiscount += data.total?.couponDiscount ? data.total.couponDiscount : 0
              totals.final += data.total ? data.total.final : 0
              this.totals = totals


              if (this.status.includes(data.status)) {
                const d = doc.data()
                documents.push({ ...d, id: doc.id, computed: computed, packages: packs, updatedOnX: d.updatedOn ? moment(d.updatedOn).format('X') : '', createdOnX: d.createdOn ? moment(d.createdOn).format('X') : '' });
              }


              // if (this.$route.params.id) {
              //   if (doc.id == this.$route.params.id) {
              //     this.orderSkus = { ...doc.data(), id: doc.id, computed: computed }
              //     this.orderModal = true
              //   }
              // }

              // if (storeIncludes) {
              // }
              // console.log('docdata',{ ...doc.data() } )
            }
          }
          if (this.$route.params.id) {
            let ik = 0
            for (let k in this.steps) {
              console.log(`Steps[${k}] has`, this.steps[k], data.status)
              if (this.steps[k].includes(data.status)) {
                console.log('iK is', ik)
                this.statusGroup = ik
              }
              ik++

            }
          }
        });
        this.toExport = toExport
        this.docSkell = JSON.parse(JSON.stringify(documents));
        this.documents = documents;
        this.loading = false;
        this.readyDoc = true
      });
    },
    getClientName(uid) {
      //console.log('getClient',uid)
      const sameUid = this.accounts.find((item) => item.uid == uid);
      //console.log('sameID',sameUid)
      return sameUid ? sameUid.company : "";
    },
  },
};
</script>

<style lang="scss">
.orders-list {


  .approved-card {
    background-color: #a8e6c1;
    /* Define a cor de fundo verde para o v-card aprovado */
  }

  .approved-card .card-content {
    background-color: #f0ffed;
    border: 2px solid #5c9770;
    /* Define uma borda verde para o conteúdo do v-card aprovado */
    border-radius: 4px;
    /* Define um raio de borda para o conteúdo do v-card aprovado */
  }

  .approved-card:hover .card-content {
    border-color: #3d684e;
    /* Altera a cor da borda ao passar o mouse sobre o v-card aprovado */

    transition: border-color 0.3s ease-in-out;
    /* Adiciona uma transição suave para a mudança da cor da borda */
  }

  .disabled-card {
    background-color: #f0f0f0;
    /* Define a cor de fundo cinza para o v-card desativado */
    opacity: 0.6;
    /* Define uma opacidade para indicar que o v-card está desativado */
    pointer-events: none;
    /* Desativa os eventos de clique no v-card */
  }

  .filter-fieldset {
    padding: 0;
    margin: 0 0 2px 0;
    flex: 1 1 10px;
    min-width: fit-content;
    border-color: rgba(0, 0, 0, 0.38);
    border-radius: 4px;
    border-collapse: collapse;
    border-style: solid;
    border-width: 1px;
    border-width: 0px;

    legend {
      font-size: 0.75rem;
      text-transform: uppercase;
      color: rgba(0, 0, 0, 0.54);
      margin: 0 3px -5px 14px;
      padding: 0 2px;
    }

    .v-input__slot {
      box-shadow: none !important;
      font-size: 0.875rem !important;
      font-weight: 500;
    }
  }

  /*.v-data-table table tbody tr{
  &:nth-child(1),&:nth-child(2),&:nth-child(3),&:first-child{
    td{
      background-color: #5c9770 !important;
    }

  } 
  
}*/

}
</style>
